(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gj-storefront"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initStorefront(scope){
    scope.querySelectorAll('[data-gj-carousel]').forEach(function(gallery){
      if(gallery.dataset.bound)return;gallery.dataset.bound='true';
      var track=gallery.querySelector('[data-gj-track]'),slides=gallery.querySelectorAll('[data-gj-slide]'),previous=gallery.querySelector('[data-gj-prev]'),next=gallery.querySelector('[data-gj-next]'),counter=gallery.querySelector('[data-gj-slide-count]');
      if(!previous||!next||slides.length<2)return;
      function index(){return Math.round(track.scrollLeft/Math.max(1,track.clientWidth))}
      function move(delta){var target=Math.max(0,Math.min(slides.length-1,index()+delta));track.scrollTo({left:target*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})}
      previous.addEventListener('click',function(){move(-1)});next.addEventListener('click',function(){move(1)});
      track.addEventListener('scroll',function(){var current=index();counter.textContent=(current+1)+' / '+slides.length;previous.disabled=current===0;next.disabled=current===slides.length-1},{passive:true});previous.disabled=true;
      track.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});
    });
    scope.querySelectorAll('.gj-hero').forEach(function(hero){
      if(hero.dataset.gjBound)return;
      hero.dataset.gjBound='true';
      var input=hero.querySelector('[data-gj-name]'),preview=hero.querySelector('[data-gj-preview-name]'),link=hero.querySelector('[data-gj-name-link]');
      if(!input||!link)return;
      var base=link.getAttribute('href'),original=preview?preview.textContent:'';
      input.addEventListener('input',function(){
        var value=input.value.trim().slice(0,12);
        if(preview)preview.textContent=value.toUpperCase()||original;
        var url=new URL(base,location.origin);
        if(value)url.searchParams.set('gj_name',value);
        link.setAttribute('href',url.pathname+url.search);
      });
      input.addEventListener('keydown',function(event){if(event.key==='Enter'){event.preventDefault();link.click()}});
    });
  }
  function launchBuilder(styleCode){
    var root=document.querySelector('.vjc');
    if(!root||root.dataset.gjReady!=='true')return false;
    if(styleCode){
      var control=root.querySelector('[data-style="'+styleCode+'"]');
      if(control)control.click();
      var body=root.querySelector('[data-material="body"]'),sleeve=root.querySelector('[data-material="sleeve"]');
      if(body&&sleeve){
        body.value=styleCode==='satin'?'Satin':'Melton wool';
        sleeve.value=styleCode==='satin'?'Satin':'Genuine leather';
        body.dispatchEvent(new Event('change',{bubbles:true}));
        sleeve.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }
    root.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
    var heading=root.querySelector('.vjc__header h2');
    if(heading){heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true})}
    return true;
  }
  document.addEventListener('click',function(event){
    var styleLink=event.target.closest('[data-gj-style]'),builderLink=event.target.closest('[data-gj-build]');
    if(styleLink&&styleLink.hasAttribute('data-gj-shop'))return;
    if(styleLink&&launchBuilder(styleLink.dataset.gjStyle))event.preventDefault();
    else if(builderLink&&launchBuilder())event.preventDefault();
  });
  initStorefront(document);
  document.addEventListener('shopify:section:load',function(event){initStorefront(event.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
